import { useRef, useEffect } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import './SellHeading.css';
import banner from '../../../assets/images/sell-with-us/banner.webp';
import expertIcon from '../../../assets/images/sell-with-us/expert-icon.png';
import authenticityIcon from '../../../assets/images/sell-with-us/authenticity-icon.png';

const cinematicEase = [0.7, 0, 0.3, 1];
const bannerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: cinematicEase },
  },
};
const circleVariants = {
  hidden: { opacity: 0, x: 150 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.6, ease: cinematicEase },
  },
};

function SellHeading() {
  const itemsRef = useRef(null);
  const itemsControls = useAnimation();
  const itemsInView = useInView(itemsRef, { once: true });

  useEffect(() => {
    itemsInView
      ? itemsControls.start('visible')
      : itemsControls.start('hidden');
  }, [itemsInView, itemsControls]);

  const scrollToSellForm = () => {
    window.scrollTo({
      top: document.getElementById('sell-form')?.offsetTop,
      behavior: 'smooth',
    });
  };

  return (
    <div className="sell-heading">
      <div className="sell-heading__container" ref={itemsRef}>
        <motion.img
          className="sell-heading__banner"
          src={banner}
          alt=""
          variants={bannerVariants}
          initial="hidden"
          animate={itemsControls}
        />

        <div className="sell-heading__content">
          <h1 className="sell-heading__title">
            Получите наилучшую цену за&nbsp;ваши роскошные&nbsp;часы
            <br />
            Просто и безопасно
          </h1>

          <p className="sell-heading__subtitle">
            Мы специализируемся на элитных проверенных часах, предлагая
            конкурентоспособные цены, оперативные платежи и полную прозрачность.
          </p>

          <ul className="sell-heading__benefits">
            <li className="sell-heading__benefit">
              <img
                className="sell-heading__expert-icon"
                src={expertIcon}
                alt=""
              />
              <p className="sell-heading__benefit-text">
                Профессиональная оценка
              </p>
            </li>
            <li className="sell-heading__benefit">
              <img
                className="sell-heading__authenticity-icon"
                src={authenticityIcon}
                alt=""
              />
              <p className="sell-heading__benefit-text">
                100% гарантия подлинности
              </p>
            </li>
          </ul>

          <div className="sell-heading__button-container">
            <button
              className="sell-heading__button"
              type="button"
              onClick={scrollToSellForm}
            >
              Получите вашу оценку
            </button>
          </div>
        </div>

        <motion.div
          className="sell-heading__bg-circle"
          variants={circleVariants}
          initial="hidden"
          animate={itemsControls}
        />
      </div>
    </div>
  );
}

export default SellHeading;
